import { AppAuthenticationService } from '@aca-new/app/shared/services/user-services/app-authentication/app-authentication.service';
import { WINDOW } from '@aca-new/app/shared/tokens/window.token';
import { ENVIRONMENT } from '@aca-new/environments/environment';
import { inject } from '@angular/core';

declare let ENV_TYPE: 'dev' | 'pp' | 'prod';

/**
 * @description
 * Handles logout triggered by the legacy ACA app.
 * ACA clears its own session and redirects the top-level window to this route.
 * This guard clears ACA-new's auth data and redirects to the marketing site.
 * @returns {boolean} always false — navigation is handled via window.location redirect
 */
export function logoutFromAcaGuard(): boolean {
  const authService = inject(AppAuthenticationService);
  const appWindow = inject(WINDOW);

  authService.clearAuthenticationData();
  appWindow.location.href = `${ENVIRONMENT[ENV_TYPE].MARKETING_WEBSITE_URL}/logout`;

  return false;
}
